import { InitialAndFollowOnPortfolios } from 'src/app/domain/pp/service/PortfolioInitialAndFollowOnCalculation';
import { Rows } from '../../interfaces';
import { dashInsteadOfNullCommon, DataType, formats, getCell, spaceInsteadOfNull, withCellStyles } from '../../utils';
import { PortfolioPerformance } from 'src/app/domain/pp/dto/PortfolioPerformance';
import { left, leftBold } from 'src/app/util/excelStyles';

export const getPreparedData = (data: InitialAndFollowOnPortfolios, headers): Rows => {
  const newData: Rows = [];
  selectedPeriod = data.selectedPeriod;
  newData.push(headers);
  addCategoryRowsToData(data.active, 'Active', headers, newData);
  addCategoryRowsToData(data.sold, 'Sold', headers, newData);
  selectedPeriod = undefined;
  return newData;
};


export const getCategoryRows = (active: PortfolioPerformance[], headers: string[]): Rows => {
  const rows: Rows = [];
  // eslint-disable-next-line
  const mappedToHeaders = active.map((pp) => getNewMapping(pp));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header] as DataType, left));
    }
    rows.push(row);
  }
  return rows;
};

export const addCategoryRowsToData = (dataArray, category, headers, newData): void => {
  if (!dataArray.length) {
    return;
  }
  const row = [];
  row.push(withCellStyles(category === 'Sold' ? 'Realized' : category, leftBold));
  newData.push(row);
  const categoryRows = getCategoryRows(dataArray, headers);
  newData.push(...categoryRows);
};

export const getNewMapping = (p: PortfolioPerformance): object => {
  const body = {
    Company: p.name,
    'Last round (name)': p.valuationRoundName,
    'Last round (date)': p.valuationRoundDate ?? '',
    'Days passed': getTextForLastRoundDate(p),
    'Current company value': getCell({
      v: dashInsteadOfNullCommon(p.valuationRoundValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Price per share': getCell({
      v: spaceInsteadOfNull(p.valuatedPps),
      z: formats.toFixed2,
      t: 'n',
    }),
    'Run rate (monthly)': getCell({
      v: spaceInsteadOfNull(p.runRate),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Burn rate (monthly)': getCell({
      v: spaceInsteadOfNull(p.burnRate),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Cash reserve (amount)': getCell({
      v: spaceInsteadOfNull(p.cashReserveAmount),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Cash reserve (monthly)': getCell({
      v: spaceInsteadOfNull(p.cashReserveInMonth),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Annual revenue': getCell({
      v: spaceInsteadOfNull(p.revenueAnnual),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Fundraising status': getCell({
      v: spaceInsteadOfNull(p.fundraisingStatus),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Product and market updates': getCell({
      v: spaceInsteadOfNull(p.prodAndMarketUpdates),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Valuation decision': getCell({
      v: spaceInsteadOfNull(p.valuationDecision),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
  };
  return body;
};

export const getTextForLastRoundDate = (p: PortfolioPerformance): string => {
  if (!p.valuationRoundDate) {
    return '';
  }
  const dateDifference = (new Date(selectedPeriod).getTime() - new Date(p.valuationRoundDate).getTime());
  return Math.floor(dateDifference / (1000 * 3600 * 24)) + ' days before current period';
};

let selectedPeriod: Date;
